module.exports = __webpack_public_path__ + "img/bottom1.59a2682e.png";